"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlvHttpDriver = void 0;
const tslib_1 = require("tslib");
const state_flow_1 = require("@video/state-flow");
const adapter_1 = require("../../../../api/adapter");
const errors_deprecated_1 = require("../../../../internal/errors-deprecated");
const bind_1 = require("../../../../internal/utils/bind");
const Audio = tslib_1.__importStar(require("../../state-flow/controls/audio"));
const Playback = tslib_1.__importStar(require("../../state-flow/controls/playback"));
const FlvHttp = tslib_1.__importStar(require("../../state-flow/drivers/flv-http"));
const encoding_selectors_1 = require("../encoding-selectors");
const helpers_1 = require("../helpers");
const register_1 = require("../register");
const common_1 = require("./common");
// returns wrapper to make sure that we use native hls
function wrap(fn) {
    const wrapper = (ss, sf) => {
        // check if nativeHls driver is in use
        if (!FlvHttp.InUse.is(sf.flvHttp)) {
            return state_flow_1.Result.ignore();
        }
        return fn(ss, sf);
    };
    Reflect.defineProperty(wrapper, "name", { configurable: true, value: fn.name });
    return wrapper;
}
class FlvHttpDriver {
    constructor(ctx) {
        this.ctx = ctx;
        this.player = null;
        // readonly debugInfo: unknown;
        this.encodingSelector = new encoding_selectors_1.HighestBitrateSelector();
        // metadata: unknown;
        this.availableEncodings = [];
        (0, bind_1.makeBounded)(this);
    }
    static isManifestSupported(manifest) {
        return (manifest === null || manifest === void 0 ? void 0 : manifest.formats["flv-http"]) != null;
    }
    static isHostSupported(host) {
        return (0, common_1.isVideoElement)(host);
    }
    static isPlatformSupported() {
        return adapter_1.device.isImplements(adapter_1.Feature.MPEGTS);
    }
    initStateFlow(sf) {
        this.sf = sf;
        sf.handleEnter(FlvHttp.Prepared, this.prepare);
        sf.handleEnter(FlvHttp.InUse, this.activate);
        sf.handleExit(FlvHttp.InUse, this.deactivate);
        // sf.onCommit(Host.Attached, this.onHostAttached);
        // sf.handleExit(Host.Attached, wrap(this.onHostDetaching));
        sf.handleEnter(Playback.Playing, wrap(this.startPlaying));
        sf.handleExit(Playback.Playing, wrap(this.stopPlaying));
        sf.handleEnter(Audio.UnMuted, wrap(this.unmute));
        sf.handleChanges(Audio.UnMuted, wrap(this.changeVolume));
        sf.handleExit(Audio.UnMuted, wrap(this.mute));
    }
    changeVolume(states) {
        const volumeChanged = (0, common_1.isVolumeChanged)(this.player.volume, states.audio.volume);
        if (!volumeChanged) {
            return state_flow_1.Result.ignore();
        }
        this.player.volume = states.audio.volume;
        return state_flow_1.Result.ok();
    }
    mute(states) {
        if (this.player.muted) {
            return state_flow_1.Result.ignore();
        }
        this.player.muted = true;
        return state_flow_1.Result.ok();
    }
    unmute(states) {
        const volumeChanged = (0, common_1.isVolumeChanged)(this.player.volume, states.audio.volume);
        if (!this.player.muted && !volumeChanged) {
            return state_flow_1.Result.ignore();
        }
        if (this.player.muted) {
            this.player.muted = false;
        }
        if (volumeChanged) {
            this.player.volume = states.audio.volume;
        }
        return state_flow_1.Result.ok();
    }
    prepare(states) {
        if (adapter_1.device.isImplements(adapter_1.Feature.MPEGTS)) {
            return state_flow_1.Result.transition(adapter_1.device.loadMpegtsScript().then(() => state_flow_1.Result.ok()));
        }
        return state_flow_1.Result.reject("mpegts is not supported");
    }
    activate({ host, manifest, audio, flvHttp }) {
        const el = (0, common_1.getVideoElement)(host.element);
        if (manifest.json == null) {
            throw new Error("manifest is null");
        }
        if (!adapter_1.device.isImplements(adapter_1.Feature.MPEGTS)) {
            throw new Error("mpegts is not supported");
        }
        const format = manifest.json.formats["flv-http"];
        const encoding = this.encodingSelector.select((0, helpers_1.parseEncodings)(format));
        if ((encoding === null || encoding === void 0 ? void 0 : encoding.location) == null || encoding.location === "") {
            throw new errors_deprecated_1.DriverNotSupportedError("invalid encoding", {});
        }
        this.player = adapter_1.device.mpegts.createPlayer({
            type: "flv",
            isLive: true,
            url: encoding.location,
        });
        this.player.attachMediaElement(el);
        this.player.load();
        this.player.volume = audio.volume;
        this.player.muted = !Audio.UnMuted.is(audio);
        return state_flow_1.Result.ok();
    }
    deactivate({ host }) {
        var _a;
        const el = (0, common_1.getVideoElement)(host.element);
        // some cleanup
        console.log("did we get here?");
        (_a = this.player) === null || _a === void 0 ? void 0 : _a.destroy();
        this.player = null;
        el.src = "";
        return state_flow_1.Result.ok();
    }
    startPlaying(states, sf) {
        // that's ok if it throws an error
        // it will be caught by state flow
        const result = this.player.play();
        if (result instanceof Promise) {
            return state_flow_1.Result.transition(result.then(() => state_flow_1.Result.ok()));
        }
        return state_flow_1.Result.ok();
    }
    stopPlaying(states, sf) {
        // that's ok if it throws an error
        // it will be caught by state flow
        this.player.pause();
        return state_flow_1.Result.ok();
    }
    async [Symbol.dispose]() {
        var _a;
        (_a = this.player) === null || _a === void 0 ? void 0 : _a.destroy();
    }
}
exports.FlvHttpDriver = FlvHttpDriver;
FlvHttpDriver.displayName = "FlvHttpDriver";
FlvHttpDriver.driverName = "flvhttp";
(0, register_1.registerVideoDrivers)(FlvHttpDriver);
//# sourceMappingURL=flv-http.js.map